import { Box, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { DeviceDetails } from 'src/api/device/types';
import { DeviceMap } from 'src/features/device/common/DeviceMap';

type Props = {
  device: DeviceDetails;
};

export const DeviceLocation: FC<Props> = memo(({ device }) => {
  if (!device?.latest_location) {
    return null;
  }

  return (
    <Box w={600}>
      <Text fw={500} mb="lg" size="lg">
        Location Details
      </Text>

      {/* TODO: location from pubsub */}
      <DeviceMap
        locations={[device.latest_location]}
        height="400px"
        popupLabel={device.playwall_id}
      />
    </Box>
  );
});

DeviceLocation.displayName = 'DeviceLocation';
